import React, { Component } from 'react'
import { Button, Card, Col, Row, Label } from 'reactstrap'
import { inject, observer } from "mobx-react";
import FormInput from "../../../../comum/components/FormInput";
import FormInputNumber from '../../../../comum/components/FormInputNumber';
import { IconeDelete } from '../../../../comum/components/Icones';
import { faBoxTissue } from '@fortawesome/free-solid-svg-icons';
import ModalAviso from '../../../../comum/components/ModalAviso';
import ModalForm from '../../../../comum/components/ModalForm';
import Checkbox from '../../../../comum/components/Checkbox';

@inject("store")
@observer
export default class DesistenciaForm extends Component {
    constructor(props){
        super(props)

        this.state = {
            cntrs: [],
            showModalSelecionarOs: false,
            cntrSelecionado: '',
            msgServicosNaoSelecionados: '',
            showModalServicosNaoSelecionados: false,
            bookingSelecionado: undefined,
            itemSelecionado: "",
            render: false
        };

        this.parametrosStore = this.props.store.parametrosStore;
        this.agendamentoController = this.props.agendamentoController
    }

    componentDidMount = () => {
        if (!this.agendamentoController.isEditar){
            this.agendamentoController.adicionarDesistencia();
        }
    }

    // campoContainer(dado, md) {
    //     if (this.parametrosStore.isAgendamentoVisible("ListaContainerContainer"))
    //         return (
    //                 <FormInput titulo="Container" xs={10} sm={10} md={8}
    //                     uppercase={true}
    //                     objeto={ this.agendamentoController.dadosAgendamento }
    //                     dado={ dado }
    //                     bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerContainer") }
    //                     onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
    //                 />
    //             );
    // };

    handleChange(){
        this.setState({render: !this.state.render});
    }

    habilitaSelecaoOs(booking, verificaSelecaoAnterior = false){

        if(!booking)
            return false;

        if(!booking.CobrarDe)
            return false;

        if(booking.SelecionouOs && verificaSelecaoAnterior)
            return false;

        if(!booking.containers[0].CodCntr)
            return false;

        if(!booking.RazaoSocial)
            return false;

        return true;
    }

    onBlurCobrarDe = async (cntr, cnpj, elemento) => {
        
        if(!cntr || !cnpj)
            return;

        try{
            let data = await this.agendamentoController.obterServicos(cntr, cnpj);

            if(data.IsSuccessfull){
                this.agendamentoController.setDadosAgendamento(`${elemento}.RazaoSocial`, { target: { value: data.RazaoSocialCobrarDe }});
                this.agendamentoController.setDadosAgendamento(`${elemento}.CodCobrarDe`, { target: { value: data.CodigoCobrarDe }});
                this.agendamentoController.setDadosAgendamento(`${elemento}.containers[0].CliBrsIdDevolucao`, { target: { value: data.CodigoCobrarDe }});
                this.agendamentoController.setDadosAgendamento(`${elemento}.Servicos`, { target: { value: data.Servicos }});
    
                this.setState({render: !this.state.render})
            }else{
                this.agendamentoController.setDadosAgendamento(`${elemento}.EstadoDeErro`, { target: { value: true }});
                this.setState({render: !this.state.render})
            }

            console.log(data);

        }catch(er){
            console.log(er);
        }

    }

    handleChangeServiceOption(CodServico, index){

        let servicoAlterado = this.state.bookingSelecionado.Servicos.find(x=> x.CodServico == CodServico);

        let value = !servicoAlterado.Selecionado;
        this.agendamentoController.setDadosAgendamento(`${this.state.itemSelecionado}.Servicos[${index}].Selecionado`, { target: { value }});

        this.setState({render: !this.state.render});
    }

    showError(booking){

        if(!booking)
            return false;

        if(!booking.EstadoDeErro)
            return false;

        return booking.EstadoDeErro;
    }

    cardContainer(){
        {console.log('render')}
        return (
            <div>
                <Row>
                    <Col>
                    {
                        this.agendamentoController.terminal == "RIG"
                        ?<h2>
                            Devolução Exportação Cabotagem
                        </h2>
                        :<h2>
                            Desistência de Exportação 
                        </h2>
                    }
                    </Col>    
                        {this.botaoAdicionar()}
                </Row>
                <Row>
                    { this.agendamentoController.atualizaRetiradas 
                    && this.agendamentoController.dadosAgendamento.listaBookings && //verificar se é listaBooking ou alguma lista de containers, já que entro com containers
                        this.agendamentoController.dadosAgendamento.listaBookings.map((booking, index)=>
                            <Col className="area-form card-form" xl={6} key={index}>
                                <Card>
                                    { this.habilitaSelecaoOs(booking, true) && (
                                        <Row>
                                            <Col xs={12} sm={12} md={12}>
                                                <p><b>Atenção: </b><br></br>
                                                Favor selecionar os serviços que devem ter as despesas direcionadas ao CNPJ informado.</p>
                                            </Col>
                                        </Row>
                                    )}

                                    { this.showError(booking) && (
                                        <Row>
                                            <Col xs={12} sm={12} md={12}>
                                                <p><b>Atenção: </b><br></br>
                                                Cliente não encontrado.</p>
                                            </Col>
                                        </Row>
                                    )}

                                    <Row>
                                        { /*this.campoContainer(`listaBookings[${index}].containers[0].CodCntr`, 12)*/ }
                                        {this.parametrosStore.isAgendamentoVisible("ListaContainerContainer") && (
                                            <FormInput titulo="Container" xs={10} sm={10} md={8}
                                                uppercase={true}
                                                objeto={ this.agendamentoController.dadosAgendamento }
                                                dado={ `listaBookings[${index}].containers[0].CodCntr` }
                                                bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerContainer") }
                                                onChange={ (event) => {
                                                    this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].containers[0].CodCntr`, event);
                                                    this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].SelecionouOs`, { target: { value: false }});
                                                    this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].EstadoDeErro`, { target: { value: false }});
                                                }}
                                                onBlur={(event)=> {
                                                    if(booking.containers && event)
                                                        this.onBlurCobrarDe(event, booking.CobrarDe, `listaBookings[${index}]`)
                                                }}
                                            />
                                        )}
                                        {
                                        process.env.rig &&
                                        <Col xs={2} sm={2} md={4}>
                                            <div className="position-relative form-group">
                                                <Label className="invisible">no title</Label>
                                                <Button 
                                                    className="btn-secundary form-control"
                                                    disabled={!this.habilitaSelecaoOs(booking)}
                                                    onClick={() => {
                                                        this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].SelecionouOs`, { target: { value: true }});
                                                        this.setState({showModalSelecionarOs:true, bookingSelecionado: booking, itemSelecionado: `listaBookings[${index}]`});
                                                    }}
                                                >Selecionar Serviços</Button>
                                            </div>
                                        </Col>
                                        }
                                    </Row>
                                    {
                                        process.env.rig &&
                                        <Row>
                                            <Col>
                                                <Row>
                                                    <FormInput titulo="Cliente / Cobrar de" xs={12} sm={12} md={4}
                                                                    uppercase={true}
                                                                    objeto={ this.agendamentoController.dadosAgendamento }
                                                                    dado={ `listaBookings[${index}].CobrarDe` }
                                                                    onChange={ (event) => {
                                                                        this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].CobrarDe`, event)
                                                                        this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].RazaoSocial`, { target: { value: '' }});
                                                                        this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].SelecionouOs`, { target: { value: false }});
                                                                        this.agendamentoController.setDadosAgendamento(`listaBookings[${index}].EstadoDeErro`, { target: { value: false }});
                                                                        //this.handleChange();
                                                                    }}
                                                                    onBlur={(event)=> {
                                                                        if(booking.containers && event)
                                                                            this.onBlurCobrarDe(booking.containers[0].CodCntr, event, `listaBookings[${index}]`)
                                                                    }}
                                                                    />
                                                    <FormInput titulo="Razão Social" xs={12} sm={12} md={8}
                                                                    bloqueado={true}
                                                                    uppercase={true}
                                                                    objeto={ this.agendamentoController.dadosAgendamento }
                                                                    dado={ `listaBookings[${index}].RazaoSocial` }
                                                                    onChange={()=>{}} 
                                                                    />
                                                </Row>
                                            </Col>
                                        </Row>
                                    }
                                </Card>
                                <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.agendamentoController.removerRetirada(index) } />
                            </Col>
                        )
                    }
                </Row>
            </div>
        )
    }

    botaoAdicionar(){
        return <Button onClick={this.agendamentoController.adicionarDesistencia} className="btn-com-bordas-primary">Novo Container</Button>
    }

    modalConfirmacaoServicosNaoSelecionados(){
        return (this.state.showModalServicosNaoSelecionados && 
            <ModalForm
                className="tamanho-modal-500"
                labelConfirmar="CONFIRMAR"
                labelCancelar="Cancelar"
                onClickSalvar={() => this.setState({ showModalServicosNaoSelecionados:false, showModalSelecionarOs: false })}
                onClickCancelar={() => this.setState({ showModalServicosNaoSelecionados:false})}
            >
                <h2>Atenção, os serviços abaixo não foram selecionados.</h2>
                
                <ul classlist="list-group list-group-flush">
                    { 
                    this.state.bookingSelecionado.Servicos.filter(x=> x.Selecionado != true ).map((item, index) =>
                        <li key={item.CodServico} classlist="list-group-item">{ item.DescricaoServico }</li>
                    )}
                </ul>
            </ModalForm>
            );
    }

    modalSelecionarOS(){

        if(!this.state.bookingSelecionado || !this.state.bookingSelecionado.Servicos)
            return (this.state.showModalSelecionarOs && 
                <ModalAviso
                    onClickFechar = {()=>{ this.setState({showModalSelecionarOs: false }) }}
                >
                    <h2>Não é possível alterar os serviços</h2>
                    <span>
                        Não foi encontrada nenhuma ordem de serviço disponível para realizar alteração do Cliente/Cobrar de.
                    </span>
                </ModalAviso>
            );
        else
            return (this.state.showModalSelecionarOs && 
                <ModalForm
                    className="tamanho-modal-500"
                    labelConfirmar="CONFIRMAR"
                    labelCancelar="Cancelar"
                    onClickSalvar={() => {
                        let servicosSelecionados = this.state.bookingSelecionado.Servicos.filter(x=> x.Selecionado != true );
                        if(servicosSelecionados.length > 0)
                            this.setState({showModalServicosNaoSelecionados:true});
                        else
                            this.setState({showModalSelecionarOs: false});
                    }}
                    onClickCancelar={() => this.setState({showModalSelecionarOs:false})}
                >
                    <h2>Seleção de Serviços</h2>
                    <table classlist="table">
                        <tbody>
                            {
                                this.state.bookingSelecionado &&
                                this.state.bookingSelecionado.Servicos.map((item, index)=> {
                                    return(
                                        <tr key={item.CodServico}>
                                            <td>{item.DescricaoServico}</td>
                                            <td>
                                                <Checkbox 
                                                    onClick={()=>{ this.handleChangeServiceOption(item.CodServico, index) }} 
                                                    ativo={this.state.bookingSelecionado.Servicos[index].Selecionado} 
                                                    bloqueado={false}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                        </table>
                </ModalForm>
            );
    }

    render() {
        return (
            this.modalConfirmacaoServicosNaoSelecionados() ||
            this.modalSelecionarOS() ||
            this.cardContainer()
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/desistencia-containers/components/DesistenciaForm.js